
























import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class ConfirmDialog extends Vue {
    @Prop({required: true})
    show!: boolean;

    @Prop({required: true})
    title!: string;

    @Prop({required: true})
    message!: string;

    @Prop({default: "Okay"})
    confirmText!: string;

    @Prop({default: "fa-check"})
    confirmIcon!: string;

    @Prop({default: "Abbrechen"})
    unConfirmText!: string;

    @Prop({default: "fa-ban"})
    unConfirmIcon!: string;
}
